import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import type { Tables } from "@msuite/utils/types";
import { client } from "@/hono";
import type { ExtendTicketCardProps } from "../ticket-card/ticket-card";
import { ProjectCard, type ProjectCardProps } from "./project-card";

/** Props Interface */
interface ProjectCardIdProps extends Pick<ProjectCardProps, "variant"> {
	projectId: string;
	tickets?: Tables<"tickets">[];
	isTicketDraggable?: boolean;
	ticketProps?: ExtendTicketCardProps;
}

export function ProjectCardId({
	projectId,
	tickets,
	isTicketDraggable,
	ticketProps,
	variant,
}: ProjectCardIdProps) {
	/** Hooks */
	const { data: project } = useQuery({
		queryKey: ["projects", projectId],
		queryFn: async () => {
			const response = await client.projects[":projectId"].$get({
				param: {
					projectId,
				},
			});
			const data = await responseHandler(response);
			return data.project;
		},
	});

	/** Guard */
	if (!project) return null;

	/** Render */
	return (
		<ProjectCard
			project={project as any}
			tickets={tickets}
			isTicketDraggable={isTicketDraggable}
			ticketProps={ticketProps}
			variant={variant}
		/>
	);
}
